<div
  #player
  [ngStyle]="{
    'background-image': 'url(' + data.holder + ')',
    'background-position': 'center center',
    'background-repeat': 'no-repeat',
    'background-size': 'cover',
    height: isIos && videoHeight > 100 ? videoHeight + 'px' : '',
    'padding-top':
      !isIos || (videoHeight && videoHeight <= 100) ? '56.25%' : 'unset',
    'border-radius': '24px',
    'margin-top': isIos && '37px'
  }"
  [ngClass]="{
    holder: !isIos && isTutorial,
    preview: !loaded && isTutorial && !isIos
  }"
>
  <div *ngIf="!loaded && !isIos" class="loading">
    <svg class="splash-spinner" viewBox="0 0 50 50">
      <circle
        class="path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="5"
      ></circle>
    </svg>
  </div>

  <img
    *ngIf="!played && loaded && !isIos"
    (click)="videoplay()"
    class="loading"
    src="assets/cookingbook/play.svg"
    alt=""
  />
</div>
